import * as React from "react";
import { Price } from "@grandvisionhq/common";
import { Text } from "@grandvisionhq/elements";
const Shipping = ({ price, labels, currency }) => /* @__PURE__ */ React.createElement("div", { className: "cart-totals__row" }, /* @__PURE__ */ React.createElement("div", { className: "cart-totals__label" }, /* @__PURE__ */ React.createElement(Text, { component: "span" }, labels.delivery)), /* @__PURE__ */ React.createElement("div", { className: "cart-totals__value" }, price > 0 ? /* @__PURE__ */ React.createElement(Price, { value: price, currency }) : /* @__PURE__ */ React.createElement(Text, { component: "span" }, labels.freeDelivery)));
export {
  Shipping
};
//# sourceMappingURL=Shipping.js.map
